import React, { Component } from 'react'
import { Menu, Responsive, Button } from 'semantic-ui-react'
import { history } from '../helpers';
import {LANG} from '../common/constants';
import {strings} from '../common/translations';
import LogoRegioneToscana from '../images/regione-toscana@2x.png'
import LogoToscanaOr from '../images/tor-menu.png'

class MainMenu extends Component {

  constructor() {
    super();
    this.state = {
      showMenu: false,
      options: [
        { key: 1, text: strings.NAVIGATION.FLOATING_MENU.OPTION_1.TEXT, url: strings.NAVIGATION.FLOATING_MENU.OPTION_1.LINK },
        { key: 2, text: strings.NAVIGATION.FLOATING_MENU.OPTION_2.TEXT, url: strings.NAVIGATION.FLOATING_MENU.OPTION_2.LINK }
      ]
    }
    this.showMenu = this.showMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    strings.setLanguage(LANG);
  }

  showMenu(event) {
    event.preventDefault();

    this.setState({ showMenu: true }, () => {
      document.addEventListener('click', this.closeMenu);
    });
  }

  closeMenu(event) {

    if (!this.dropdownMenu.contains(event.target)) {

      this.setState({ showMenu: false }, () => {
        document.removeEventListener('click', this.closeMenu);
      });

    }
  }

  UNSAFE_componentWillMount() {
    this.unlisten = history.listen((location, action) => {
      this.setState({
        activeItem: history.location.pathname.substr(1) === '' ? 'home' : history.location.pathname.substr(1)
      })

    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidMount() {
    this.setState({
      activeItem: history.location.pathname.substr(1) === '' ? 'home' : history.location.pathname.substr(1)
    })
  }

  handleItemClick = (e, { name }) => {
    this.setState({ activeItem: name })
    name === 'home' ? history.push(`/`) : history.push(`/` + name);
    window.scrollTo(0,0);
  }

  render() {

    const { activeItem, options } = this.state;

    return (
      <Menu className='position-fixed w-100' borderless>
        <Menu.Item header className="p-0"><img src={LogoRegioneToscana} alt="Regione Toscana" className="main-menu_toscana mr-2" /></Menu.Item>
        <Menu.Item className="">
          <a href={strings.COMMON.TOSCANA_URL} className="external-link" rel="noopener noreferrer" target='_blank'>
            <img src={LogoToscanaOr} alt="Regione Toscana" className="main-menu_toscanaor mr-2" />
          </a>
        </Menu.Item>
        <Responsive as={Menu.Item} minWidth={790}
          name='home'
          active={activeItem === 'home'}
          onClick={this.handleItemClick}
        />
        <Menu.Item
          name={strings.NAVIGATION.SECTION_1.URL}
          active={activeItem === strings.NAVIGATION.SECTION_1.URL}
          onClick={this.handleItemClick}
        />
        <Menu.Item
          name={strings.NAVIGATION.SECTION_2.URL}
          active={activeItem === strings.NAVIGATION.SECTION_2.URL}
          onClick={this.handleItemClick}
        />
        <Menu.Item
          name={strings.NAVIGATION.SECTION_3.URL}
          active={activeItem === strings.NAVIGATION.SECTION_3.URL}
          onClick={this.handleItemClick}
        />
        <Menu.Item
          name={strings.NAVIGATION.SECTION_4.URL}
          active={activeItem === strings.NAVIGATION.SECTION_4.URL}
          onClick={this.handleItemClick}
        />
        <Menu.Item position='right' className="position-relative">
            <Button basic icon='info' onClick={this.showMenu} />
            {
              this.state.showMenu
                ? (
                  <div
                    className="menu-collapsed-options position-absolute"
                    ref={(element) => {
                      this.dropdownMenu = element;
                    }}
                  >
                    {
                      options.map(function(option) {
                      return <a key={option.key} className="external-link" rel="noopener noreferrer" target="_blank" href={option.url}>{option.text}</a>
                      })
                    }
                    <small className="version-tag text-muted p-2 d-block">{strings.NAVIGATION.FLOATING_MENU.UPDATE}</small>
                  </div>
                )
                : (
                  null
                )
            }
        </Menu.Item>
      </Menu>
    )
  }
}

export default (MainMenu)